'use strict';
import iziToast from 'izitoast';
import 'izitoast/dist/css/iziToast.min.css';

import {
  createGallery,
  clearGallery,
  showLoader,
  hideLoader,
  notFound,
} from './js/render-functions.js';
import getImagesByQuery from './js/pixabay-api';

const form = document.querySelector('.form');

form.addEventListener('submit', event => {
  event.preventDefault();

  clearGallery();
  showLoader();

  const query = document.querySelector('[name="search-text"]').value.trim();

  if (query === '') {
    iziToast.warning({
      title: 'Warning',
      message: 'Please enter a search query.',
      position: 'topRight',
    });
    hideLoader();
    return;
  }

  getImagesByQuery(query)
    .then(hits => {
      if (hits.length === 0) {
        notFound(query);
        return;
      }
        createGallery(hits);
      
    })

    .catch(error => {
      iziToast.error({
        title: 'Error',
        message: `An error occurred: ${error.message}`,
        position: 'topRight',
      });
    })

    .finally(() => {
      hideLoader();
      form.reset();
    });
});
